import React from 'react';
import DealerAd from '../DealerAd/DealerAd';
import queryString from 'query-string';

const App: React.FC = () => {
  const options: any = queryString.parse(location.search);

  if (!options) {
    return null;
  }

  return (
    <DealerAd
      translationVersion={window.__DEALER_T_VERSION__}
      realEstateId={options.realEstateId || ''}
      userGuid={options.userGuid || ''}
      biClientId={options.biClientId || ''}
      biClientIdSigned={options.biClientIdSigned || ''}
      withCloseButton={options.withCloseButton || false}
    />
  );
};

export default App;
